import { EluveError, EluveErrorArgs } from './eluve-error';
import { LogLevel } from './types';

export class ServiceError extends EluveError {
  static override readonly errorName = 'ServiceError';
  readonly logLevel: LogLevel = 'error';

  constructor(message = 'Service error', args?: EluveErrorArgs) {
    super(message, args);
  }
}
